<form class="xr-photo" [formGroup]="profileForm" (ngSubmit)="onSubmit()">
  <span class="xr-avatar xr-photo-avatar">
    <img [src]="avatar" [alt]="'profile_image.photo_alt' | translate"/>
  </span>

  <input type="file" accept="image/png,image/jpeg,image/jpg" class="xr-sr-only" tabindex="-1" aria-hidden="true"
         (change)="onFileSelected($event)" #fileInput>
  <button type="button" class="xr-btn xr-btn--secondary" (click)="fileInput.click()">
    {{ "profile_image.change_photo" | translate }}
  </button>
  <span class="xr-photo-note">{{ "profile_image.allowed_file" | translate }}</span>

  @if (selectedFile) {
    <p class="xr-photo-error" role="alert" *ngIf="profileForm.get('avatar')?.hasError('invalidFileType')">
      {{ "profile_image.invalid_file_type" | translate }}
    </p>
    <p class="xr-photo-error" role="alert" *ngIf="profileForm.get('avatar')?.hasError('invalidFileSize')">
      {{ "profile_image.file_too_large" | translate }}
    </p>
    <div class="xr-photo-actions">
      <button type="button" class="xr-btn xr-btn--secondary xr-btn--small" (click)="resetProfileImage()">
        {{ "profile_image.reset" | translate }}
      </button>
      <button type="submit" class="xr-btn xr-btn--primary xr-btn--small" [disabled]="!profileForm.valid">
        {{ "profile_image.upload" | translate }}
      </button>
    </div>
  }
</form>
